const reabRouteLevelOneHeader = [
  {
    group: 'Rota',
    columns: [
      {
        name: 'Rota',
        id: 'id-id',
        show: true
      },
      {
        name: 'Veiculo',
        id: 'rota-veiculo',
        show: true
      },
      {
        name: 'Tipo Reab',
        id: 'rota-type',
        show: true
      },
      {
        name: 'Dia da Semana',
        id: 'rota-dia',
        show: true
      },
      {
        name: 'CD Origem',
        id: 'rota-cd',
        show: true
      },
      {
        name: 'Lojas',
        id: 'rota-loja-id',
        show: true
      },
      {
        name: 'Agrupar',
        id: 'rota-agrupar',
        show: true
      },
      {
        name: 'Carga Especial',
        id: 'rota-peso',
        show: true
      }
    ]
  }
]
export default reabRouteLevelOneHeader
